import classNames from 'classnames';
import Typography from '@alltrails/core/components/Typography';
import CheckCircleFilled from '../../icons/CheckCircleFilled';
import Clear from '../../icons/Clear';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import styles from './styles/styles.module.scss';

type SwitchProps = {
  className?: string;
  disabled?: boolean;
  labelText: string;
  labelTextVariant?: 'text200' | 'text200bold';
  onChange: (selected: boolean) => void;
  selected?: boolean;
  subText?: string;
  width?: 'auto' | 'full';
};

const Switch = ({ className, disabled, labelText, labelTextVariant = 'text200', onChange, selected, subText, width = 'auto' }: SwitchProps) => (
  <label {...setDenaliAttribute('Switch')} className={classNames(styles.container, styles[width], disabled && styles.disabled, className)}>
    <div className={styles.labels}>
      <Typography component="span" variant={labelTextVariant}>
        {labelText}
      </Typography>
      {subText && <span className={styles.subText}>{subText}</span>}
    </div>
    <input
      checked={selected}
      disabled={disabled}
      onChange={e => {
        onChange(e.target.checked);
      }}
      type="checkbox"
      aria-label={labelText}
    />
    <div className={styles.switch}>
      <span className={styles.thumb}>{selected ? <CheckCircleFilled color="currentColor" /> : <Clear color="currentColor" />}</span>
    </div>
  </label>
);

export default Switch;
